module.exports = __webpack_public_path__ + "img/黄浦区南京街道敬老院2.10561de3.jpeg";